import { Component, Input } from "@angular/core";
import { NbButtonModule, NbCardModule, NbDialogRef } from "@nebular/theme";
import { AssetContent } from "@helix/client";
import { NgFor, NgIf } from "@angular/common";

@Component({
  selector: "ngx-asset-info-popup",
  templateUrl: "./asset-info-popup.component.html",
  styleUrls: ["./asset-info-popup.component.scss"],
  imports: [NbCardModule, NgIf, NgFor, NbButtonModule],
})
export class AssetInfoPopupComponent {
  @Input() assetName: string | null;
  @Input() assetContent: AssetContent[] = [];

  constructor(protected ref: NbDialogRef<any>) {}

  close(): void {
    this.ref.close();
  }
}
